// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_j8-0";
export var fileCarousel = "_j8-2";
export var removeFileButton = "_j8-1";